import React from "react";
import HeaderNavigation from "../templates/common/headerNav/headerNavigation";
import Footer from "../templates/common/footer";

function mainLayout({ children, ...props }) {
  return (
      <React.Fragment>
        <HeaderNavigation spacer={props.layout?.spacer !== false}/>
        {
          children
        }
        {
          props.layout?.footer !== false && <Footer/>
        }
      </React.Fragment>
  )
}

export default mainLayout;